import { DesignerPageContainer } from './DesignerPageContainer';

export default DesignerPageContainer;
